var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromosActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#E4FD3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0007 18.9995C12.7355 18.9995 12.4812 19.1048 12.2936 19.2923C12.1061 19.4799 12.0007 19.7342 12.0007 19.9995V33.4995C12.0007 35.3895 13.6107 36.9995 15.5007 36.9995H32.5007C34.3907 36.9995 36.0007 35.4676 36.0007 33.5776V19.9995C36.0007 19.7342 35.8954 19.4799 35.7078 19.2923C35.5203 19.1048 35.266 18.9995 35.0007 18.9995H13.0007Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.001 19.0012V17.0009C18.001 15.4094 18.6332 13.883 19.7586 12.7576C20.884 11.6323 22.4103 11 24.0018 11V11C25.5934 11 27.1197 11.6323 28.2451 12.7576C29.3705 13.883 30.0027 15.4094 30.0027 17.0009V19.0012",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.001 21.9993V22.9995C18.001 24.591 18.6332 26.1173 19.7586 27.2427C20.884 28.3681 22.4103 29.0003 24.0018 29.0003C25.5934 29.0003 27.1197 28.3681 28.2451 27.2427C29.3705 26.1173 30.0027 24.591 30.0027 22.9995V21.9993",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromosActive);
export default __webpack_public_path__ + "static/media/promos-active.9c94673f262fd7131d419b947a63ba48.svg";
export { ForwardRef as ReactComponent };